export default __webpack_public_path__ + "partner_13c837b1.png";